import { LeaderboardMultiplier } from '@/types/leaderboard.types';
import { actionLabelMap } from './types';

interface LeaderboardActionSettingCardProps {
  setting: LeaderboardMultiplier;
}

const LeaderboardActionSettingCard: React.FC<LeaderboardActionSettingCardProps> = ({ setting }) => (
  <div className="action-setting-card">
    <div className="action-setting-card-title">{actionLabelMap[setting.action]}</div>
    <div className="action-setting-card-value">
      {setting.multiplier} {setting.multiplier === 1 ? 'Point' : 'Points'}
    </div>
  </div>
);

export default LeaderboardActionSettingCard;
